<template>
    <div>
        <el-carousel height="350px">
            <el-carousel-item v-for="m in sList" :key="m.id">
                <a href="javascript:;">
                    <img class="s-img" :src="rImg(m.img)" :onerror="errImg" alt="">
                </a>
            </el-carousel-item>
        </el-carousel>

        <h3 class="item-title"><span class="line"></span>公司介绍<span class="line"></span></h3>
        <div class="company">
            <img class="c-img" src="../../assets/company.jpg" alt="">
            <div class="pre" v-html="info.body"></div>
        </div>
        <h3 class="item-title"><span class="line"></span>相关产品<span class="line"></span></h3>
        <div class="content-wrap">
            <dyList :list="list"></dyList>
            <div class="page-box" v-show="total">
                <el-pagination :pager-count="5" :page-size="10" @current-change="changePage" background layout="prev, pager, next" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import dyList from "@components/common/dy-list";
    import {
        mapGetters,
        mapMutations
    } from 'vuex';

    export default {
        components: {
            dyList,
        },
        data() {
            return {
                list: [],
                sList: [], // 轮播
                total: 0,
                info: {}
            };
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
        },
        mounted() {
            // 在组件被挂载之后调用。
            this.getData();
            this.getPage()
        },
        methods: {
            // ...mapMutations([])
            changePage(s) {
                this.getData(s);
            },
            // 获取轮播
            async getData(page) {
                let {
                    data
                } = await this.$y_ajax("api/mall.goods/index", {
                    score: 0,
                    page: page || 1
                });
                this.list = data.goods.data;
                this.sList = data.slides;
                this.total = data.goods.total;
            },
            async getPage() {
                const {
                    data
                } = await this.$y_ajax("api/page/view", {
                    id: 48
                });
                if (data) {
                    this.info = data;
                }
            },
        },
        computed: {
            // 计算属性
            // ...mapGetters([])
        },
        watch: {
            // 监听

        }
    };
</script>

<style lang="less" scoped>
    .s-img {
        height: 350px;
        width: 100%;
    }

    .item-title {
        margin: 50px 0;
        text-align: center;
        font-size: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .line {
        height: 1px;
        width: 60px;
        background: #ccc;
        display: inline-block;
        margin:0 10px;
    }

    .company {
        display: flex;
        padding: 30px 0;

        .c-img {
            width: 40%;
            margin-right: 25px;
        }

        .pre {
            flex: 1;
            font-size: 18px;
            line-height: 1.8;
        }
    }
</style>